import { createFileRoute } from '@tanstack/react-router';
import { PartnersPage } from '@/components/partners/PartnersPage';

export const Route = createFileRoute('/_authenticated/partners/')({
  component: PartnersPage,
});
